// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-card[data-v-38684ab6]{background:linear-gradient(270deg,#3fc5e0 0,#a67ff5 26.52%,#f46b77 84.34%,#ff691f);border-radius:8px;padding:4px}.gradient-card-body[data-v-38684ab6]{background-color:var(--color-cases-content-bg);border-radius:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
